// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nimg.preview[data-v-4e17d3f2] {\n    max-width: 100%;\n    max-height: 300px;\n    object-fit: contain;\n}\nimg.grid-preview[data-v-4e17d3f2] {\n    max-width: 100%;\n    max-height: 80px;\n    object-fit: contain;\n}\ni.icon-4x[data-v-4e17d3f2] {\n    right: 10px;\n    top: 10px;\n    position: absolute;\n}\n", ""]);
// Exports
module.exports = exports;
